import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 24,
  background: `linear-gradient(90deg, #42F 0%, ${theme.colors.primary['500']} 106.48%)`,
  borderTopLeftRadius: theme.radii.xxl,
  borderTopRightRadius: theme.radii.xxl,
}));
